// Stock photos from Unsplash (free for commercial use, no attribution required).
// Replace each `image:` URL with a real photo when available.

const gallery = [
  {
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80&auto=format&fit=crop",
    label: "Umzüge",
    caption: "Sorgfältig verpackt und sicher transportiert",
  },
  {
    image:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=900&q=80&auto=format&fit=crop",
    label: "Reinigungen",
    caption: "Endreinigung mit Abnahmegarantie",
  },
  {
    image:
      "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=900&q=80&auto=format&fit=crop",
    label: "Transport",
    caption: "Lieferungen und Kurierdienst",
  },
  {
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?w=900&q=80&auto=format&fit=crop",
    label: "Logistik",
    caption: "Fachgerechte Entsorgung und Recycling",
  },
  {
    image:
      "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&q=80&auto=format&fit=crop",
    label: "Unser Team",
    caption: "Persönlich, freundlich, zuverlässig",
  },
  {
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=80&auto=format&fit=crop",
    label: "Unsere Fahrzeuge",
    caption: "Moderne Fahrzeuge für jede Grösse",
  },
];

export default gallery;